export const DEFAULT_LOCALE = 'en-US';

export interface ILocaleAttribute {
  name: string;
  value: string;
}
export interface ILocaleDefinition {
  [key: string]: ILocaleAttribute;
}

export const locales: ILocaleDefinition = {
  'en-US': {
    name: 'English - EN',
    value: 'en-US',
  },
  'ar-AE': {
    name: `العربية` + ` - AR`,
    value: 'ar-AE',
  },
  'fr-FR': {
    name: 'Français - FR',
    value: 'fr-FR',
  },
  'pt-PT': {
    name: 'Português - PT',
    value: 'pt-PT',
  },
  'zh-CN': {
    name: '中国人 - CN',
    value: 'zh-CN',
  },
  'zh-TW': {
    name: '中国人 - TW',
    value: 'zh-TW',
  },
  'bn-IN': {
    name: 'বাঙালি - BN',
    value: 'bn-IN',
  },
  'de-DE': {
    name: 'Deutsch - DE',
    value: 'de-DE',
  },
  'mr-IN': {
    name: 'मराठी - MR',
    value: 'mr-IN',
  },
  'ta-IN': {
    name: 'தமிழ் - TA',
    value: 'ta-IN',
  },
  'hi-IN': {
    name: 'हिंदी - HI',
    value: 'hi-IN',
  },
  'te-IN': {
    name: 'టెలెగు - TE',
    value: 'te-IN',
  },
  'es-ES': {
    name: 'Español - ES',
    value: 'es-ES',
  },
  'it-IT': {
    name: 'Italiano - IT',
    value: 'it-IT',
  },
  'ja-JP': {
    name: '日本人 - JA',
    value: 'ja-JP',
  },
  'pl-PL': {
    name: 'Polski - PL',
    value: 'pl-PL',
  },
  'tr-TR': {
    name: 'Türk - TR',
    value: 'tr-TR',
  },
  'kn-IN': {
    name: 'ಕನ್ನಡ - KN',
    value: 'kn-IN',
  },
  'vi-VN': {
    name: 'Tiếng Việt - VI',
    value: 'vi-VN',
  },
  'sv-SE': {
    name: 'Svenska - SE',
    value: 'sv-SE',
  },
  'nl-NL': {
    name: 'Nederlands - NL',
    value: 'nl-NL',
  },
  'en-IE': {
    name: 'English - IE',
    value: 'en-IE',
  },
};

export const spimSupportedLocales = [
  locales['en-US'],
  locales['ja-JP'],
  locales['zh-CN'],
];

export const sustainabilitySupportedLocales = [
  locales['en-US'],
  locales['ar-AE'],
  locales['fr-FR'],
  locales['pt-PT'],
  locales['zh-CN'],
  locales['zh-TW'],
  locales['bn-IN'],
  locales['de-DE'],
  locales['mr-IN'],
  locales['ta-IN'],
  locales['hi-IN'],
  locales['te-IN'],
  locales['es-ES'],
  locales['it-IT'],
  locales['ja-JP'],
  locales['pl-PL'],
  locales['tr-TR'],
  locales['kn-IN'],
  locales['vi-VN'],
];

export const dsaOutOfCourtSettlementSupportedLocales = [
  locales['en-US'],
  locales['ar-AE'],
  locales['fr-FR'],
  locales['pt-PT'],
  locales['zh-CN'],
  locales['zh-TW'],
  locales['bn-IN'],
  locales['de-DE'],
  locales['mr-IN'],
  locales['ta-IN'],
  locales['hi-IN'],
  locales['te-IN'],
  locales['es-ES'],
  locales['it-IT'],
  locales['ja-JP'],
  locales['pl-PL'],
  locales['tr-TR'],
  locales['kn-IN'],
  locales['vi-VN'],
  locales['sv-SE'],
  locales['nl-NL'],
];

export const csamSupportedLocales = [
  locales['en-US'],
  locales['fr-FR'],
  locales['de-DE'],
  locales['es-ES'],
  locales['it-IT'],
  locales['pl-PL'],
  locales['sv-SE'],
  locales['nl-NL'],
  locales['pt-PT'],
  locales['en-IE'],
];

export const paymentComplaintSupportedLocales = [
  locales['en-US'],
  locales['fr-FR'],
  locales['pt-PT'],
  locales['de-DE'],
  locales['es-ES'],
  locales['it-IT'],
  locales['pl-PL'],
  locales['tr-TR'],
  locales['sv-SE'],
  locales['nl-NL'],
];

export const defaultSupportedLocales = [
  locales['en-US'],
  locales['ar-AE'],
  locales['fr-FR'],
  locales['pt-PT'],
  locales['zh-CN'],
  locales['zh-TW'],
  locales['bn-IN'],
  locales['de-DE'],
  locales['mr-IN'],
  locales['ta-IN'],
  locales['hi-IN'],
  locales['te-IN'],
  locales['es-ES'],
  locales['it-IT'],
  locales['ja-JP'],
  locales['pl-PL'],
  locales['tr-TR'],
  locales['kn-IN'],
  locales['vi-VN'],
  locales['sv-SE'],
  locales['nl-NL'],
];

export const MessageBundleId = {
  COMMON_BUNDLE: 'com.amazon.lens.cpr.common.common',
  MENU_BUNDLE: 'com.amazon.lens.cpr.common.menu',
  MESSAGE_BUNDLE: 'com.amazon.lens.cpr.common.message',
  FILE_UPLOADER_BUNDLE: 'com.amazon.lens.cpr.components.fileUploader',
  GTS_BUNDLE: 'com.amazon.lens.cpr.ddm.gts.gts',
  PRODUCT_SAFETY_BUNDLE: 'com.amazon.lens.cpr.ddm.product-safety.productSafety',
  SOCIAL_RESPONSIBILITY_BUNDLE:
    'com.amazon.lens.cpr.ddm.sustainability.socialResponsibility',
  SOCIAL_RESPONSIBILITY_LANDING_PAGE_BUNDLE:
    'com.amazon.lens.cpr.ddm.sustainability.landingPage',
  DSA_OUT_OF_COURT_SETTLEMENT_BUNDLE:
    'com.amazon.lens.cpr.ddm.dsa-out-of-court-settlement.dsaOocs',
  CSAM_BUNDLE: 'com.amazon.lens.cpr.ddm.csam.csam',
  PAYEMENT_SERVICES_COMPLAINT_BUNDLE:
    'com.amazon.lens.cpr.ddm.payment-services-complaint.landingPage',
  CASE_DETAILS_BUNDLE: 'com.amazon.lens.cpr.pages.caseDetails',
  CASE_LIST_BUNDLE: 'com.amazon.lens.cpr.pages.caseList',
  CASE_SUMMARY_BUNDLE: 'com.amazon.lens.cpr.pages.caseSummary',
  COMMUNICATION_PAGE_BUNDLE: 'com.amazon.lens.cpr.pages.communicationPage',
  CREATE_CASE_BUNDLE: 'com.amazon.lens.cpr.pages.createCase',
};
